import { produce } from 'immer';
import { mutateClosePreview } from '../utils/pagesPreview';
import { getContainerPrintIds } from '../utils/containers';

export const pagesPreviewActions = (set, get) => ({
  closePreview: () => {
    set(
      produce((draft) => {
        mutateClosePreview(draft);
      }),
      false,
      `close preview`
    );
  },
  appendPages: (containerIndex) => {
    const { containers, columns, pagesPreview } = get();
    // Un container dont les lignes principales ont été aplaties par le service
    // PDF n'apparaît dans l'aperçu que sous l'id de chacune de ses lignes.
    const findPageIdx = (container) => {
      const printIds = getContainerPrintIds(container, columns);
      return pagesPreview.findIndex((page) =>
        page.printedContainers.some((c) => printIds.includes(c.id))
      );
    };
    // Le container désigné peut être absent de l'aperçu (masqué, ancre de
    // section liée, moitié cachée d'une séparation de chapitre, ou index -1
    // quand on retire le premier) : on remonte jusqu'au dernier imprimé. Aucun :
    // tout le chapitre est recalculé plutôt que de laisser l'aperçu périmé.
    let pageHoldingIdx = -1;
    for (let i = containerIndex ?? -1; i >= 0 && pageHoldingIdx < 0; i--) {
      pageHoldingIdx = findPageIdx(containers[i]);
    }
    const containerInPagesPreviewExcluded =
      pagesPreview[pageHoldingIdx]?.printedContainers ?? [];
    const pagesPreviewExcludedIdx = Math.max(
      0,
      pagesPreview.findIndex((page) =>
        containerInPagesPreviewExcluded.some((c) =>
          page.printedContainers.some((pC) => pC.id === c.id)
        )
      )
    );
    set(
      produce((draft) => {
        draft.pagesPreviewExcludedIdx = pagesPreviewExcludedIdx;
      }),
      false,
      `append page after ${pagesPreviewExcludedIdx}`
    );
    get().saveAndGeneratePdf('preview', pagesPreviewExcludedIdx);
  },
});
